import { createContext } from 'react';

interface ICustomWindow extends Window {
  initialAppState?: any;
}

const customWindow: ICustomWindow = window;

const PathContext = createContext(
  location.hostname !== 'localhost' &&
    location.hostname !== '127.0.0.1' &&
    customWindow.initialAppState.pathContext
    ? customWindow.initialAppState.pathContext
    : '',
);

export default PathContext;
